import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AuthProvider } from './context';
import { PrivateRoute, PublicRoute, AdminRoute } from './routes';
import { Layout } from './components';
import { ROUTES } from './constants';

const HomePage = lazy(() => import('./pages/HomePage').then(m => ({ default: m.HomePage })));
const LoginPage = lazy(() => import('./pages/LoginPage').then(m => ({ default: m.LoginPage })));
const SchedulePage = lazy(() => import('./pages/SchedulePage').then(m => ({ default: m.SchedulePage })));
const EquipmentPage = lazy(() => import('./pages/EquipmentPage').then(m => ({ default: m.EquipmentPage })));
const ProductsPage = lazy(() => import('./pages/ProductsPage').then(m => ({ default: m.ProductsPage })));
const UserManagementPage = lazy(() => import('./pages/UserManagementPage').then(m => ({ default: m.UserManagementPage })));
const QrConfirmPage = lazy(() => import('./pages/QrConfirmPage').then(m => ({ default: m.QrConfirmPage })));
const MetricsPage = lazy(() => import('./pages/MetricsPage').then(m => ({ default: m.MetricsPage })));
const ConfigPage = lazy(() => import('./pages/ConfigPage').then(m => ({ default: m.ConfigPage })));

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={null}>
        <Routes>
          {/* Public routes - restricted means redirect to home if authenticated */}
          <Route element={<PublicRoute restricted />}>
            <Route path={ROUTES.LOGIN} element={<LoginPage />} />
          </Route>

          {/* QR confirm page - accessible to both authenticated and unauthenticated users */}
          <Route element={<PublicRoute />}>
            <Route path={ROUTES.QR_LOGIN} element={<QrConfirmPage />} />
          </Route>

          {/* Private routes - require authentication */}
          <Route element={<PrivateRoute />}>
            <Route element={<Layout />}>
              <Route path={ROUTES.HOME} element={<HomePage />} />
              <Route path={ROUTES.SCHEDULE} element={<SchedulePage />} />
              <Route path={ROUTES.EQUIPMENT} element={<EquipmentPage />} />
              <Route path={ROUTES.PRODUCTS} element={<ProductsPage />} />
              <Route path={ROUTES.METRICS} element={<MetricsPage />} />
            </Route>
          </Route>

          {/* Admin routes - require admin role */}
          <Route element={<AdminRoute />}>
            <Route element={<Layout />}>
              <Route path={ROUTES.ADMIN_USERS} element={<UserManagementPage />} />
              <Route path={ROUTES.ADMIN_CONFIG} element={<ConfigPage />} />
            </Route>
          </Route>

          {/* Redirect unknown routes to home */}
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
